const global = window

inputs.fn.pie = {
    set(input, newVal) {
        const container = input.closest('.pie__chart')
        const cell = container.parent()
        const min = (parseInt(input.attr('min'))) ? parseInt(input.attr('min')) : 0
        const max = (parseInt(input.attr('max'))) ? parseInt(input.attr('max')) : 100
        let val = parseInt(input.val(), 10)
        if (isNaN(val)) val = min
        if (newVal !== undefined) {
            val = parseInt(newVal, 10)
            if (isNaN(val)) val = min
        }

        if (val <= min) {
            val = min
            cell.addClass('pie--empty')
        } else {
            cell.removeClass('pie--empty')
        }
        if (max && val >= max) {
            val = max
            cell.addClass('pie--complete')
        } else {
            cell.removeClass('pie--complete')
        }
        if (input.val() !== String(val)) input.val(val)
        container.attr('style', '--p:' + val + ';')
        const percent = (max > min) ? (((val - min) * 100) / (max - min)) : val
        const progressEl = container.find('.progress')
        if (progressEl.length) {
            progressEl.css('width', percent + '%').attr('data-progress', val)
            const target = progressEl.attr('data-target') || 'low'
            progressEl.removeClass('progress--green progress--yellow progress--red progress--full progress--exceeding')
            if (target === 'low') {
                if (percent > 100) {
                    progressEl.addClass('progress--exceeding')
                } else if (percent >= 80) {
                    progressEl.addClass('progress--red')
                } else if (percent >= 60) {
                    progressEl.addClass('progress--yellow')
                } else {
                    progressEl.addClass('progress--green')
                }
            } else {
                progressEl.addClass('progress--green')
            }
            if (percent >= 100) {
                progressEl.addClass('progress--full')
            }
        }
        container.find('.pie__fill').css('width', percent + '%')
        container.find('.pie__text').text(val + (container.hasClass('pie__chart--classic') ? '%' : ''))
    }
}

inputs.types.pie = function (data, name, niceName, type, input, parent, inputWindow) {
    const container = input.closest('.pie__chart')
    const cell = container.parent()
    let isDragging = false;
    let dragChanged = false;

    cell.click(function (event) {
        if (isDragging || dragChanged) {
            dragChanged = false;
            return;
        }
        const spinnedInput = $(this).find('input')
        spinnedInput.focus()
        spinnedInput.select()
        event.preventDefault()
        event.stopPropagation()
    })

    input.bind('input', function () {
        inputs.fn.pie.set(input);
    });

    input.bind('keydown', function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            input.blur();
        }
    });

    if (!data.disabled) {
        cell.bind('touchstart mousedown', function (event) {
            if (event.type === 'mousedown' && event.which !== 1) return; // Seul le clic gauche

            event.preventDefault()
            event.stopPropagation()

            if (event.type == 'touchstart') {
                event = event.originalEvent.targetTouches[0]
            }

            let spinnedInput = $(this).find('input')
            spinnedInput.blur();

            const isClassic = container.hasClass('pie__chart--classic')
            spinnedInput.data('startX', event.pageX)
            spinnedInput.data('startY', event.pageY)
            spinnedInput.data('value', spinnedInput.val())
            spinnedInput.data('original', spinnedInput.val())

            let hasMoved = false;

            const onMove = (moveEv) => {
                if (moveEv.type == 'touchmove') {
                    moveEv = moveEv.originalEvent.changedTouches[0]
                }

                let pxToChangeValue = 3
                let delta
                if (isClassic) {
                    delta = moveEv.pageX - spinnedInput.data('startX')
                } else {
                    delta = spinnedInput.data('startY') - moveEv.pageY
                }

                if (Math.abs(delta) > 2) {
                    if (!hasMoved) {
                        hasMoved = true;
                        isDragging = true;
                        container.addClass('pie__chart--drag');
                    }
                    const increment = parseInt(delta / pxToChangeValue, 10)
                    let newVal = parseInt(spinnedInput.data('value'), 10) + increment
                    inputs.fn.pie.set(spinnedInput, newVal);
                }
            };

            const onEnd = () => {
                $(document).off('touchmove mousemove', onMove)
                $(document).off('touchend mouseup', onEnd)

                if (hasMoved) {
                    dragChanged = true;
                    container.removeClass('pie__chart--drag');
                    if (spinnedInput && spinnedInput.data('original') != spinnedInput.val()) {
                        spinnedInput.data('original', spinnedInput.val());
                        spinnedInput.trigger('change');
                    }
                } else {
                    // C'était un simple clic, donner le focus
                    spinnedInput.focus();
                    spinnedInput.select();
                }

                setTimeout(() => {
                    isDragging = false;
                }, 50);
            };

            $(document).on('touchmove mousemove', onMove);
            $(document).on('touchend mouseup', onEnd);
        })
    }
    return data
}
